module.exports = __webpack_public_path__ + "img/kt.f785cf26.png";